import { useTheme } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';

interface DoughnutChartProps {
    title: string;
    seriesData: {
        value: number;
        name: string;
    }[];
    showLegend?: boolean;
}

export interface ChartDataItem {
    value: number;
    name: string;
    itemStyle?: {
        color: string;
    };
}

const DoughnutChart = ({
    title,
    seriesData,
    showLegend = true,
}: DoughnutChartProps) => {
    const theme = useTheme();

    const option = {
        title: {
            text: title,
            left: 'right',
            textStyle: {
                color: theme.palette.primary.main,
                fontStyle: 'normal',
                fontWeight: 500,
                fontFamily: 'Poppins',
                fontSize: 16,
            },
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            textStyle: {
                color: theme.palette.text.primary,
                fontFamily: 'Poppins',
            },
            show: showLegend,
        },
        series: [
            {
                name: title,
                type: 'pie',
                radius: ['50%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center',
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '18',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins',
                        color: theme.palette.primary.main,
                    },
                },
                labelLine: {
                    show: false,
                },
                data: seriesData,
            },
        ],
    };

    return (
        <ReactECharts
            option={option}
            style={{ width: '100%', height: '100%' }}
        />
    );
};

export default DoughnutChart;
